/**
 * Opt-in logging for session persistence (avoid noisy consoles in dev/prod by default).
 * Set REACT_APP_SESSION_PERSIST_DEBUG=true to enable structured persist logs.
 */

function persistDebugEnabled() {
  try {
    if (typeof process !== 'undefined' && process.env?.REACT_APP_SESSION_PERSIST_DEBUG === 'true') {
      return true;
    }
  } catch {
    /* ignore */
  }
  return false;
}

/** Structured snapshot summary (no player ids / PII by default). */
export function sessionPersistDebugSummary(sessionId, { nextAssignments, waitingList, courtAssignments }) {
  const countCourts = (rows) =>
    (rows || []).reduce((n, r) => n + (Array.isArray(r?.team1) ? r.team1.length : 0) + (Array.isArray(r?.team2) ? r.team2.length : 0), 0);
  return {
    sessionId,
    nextCourts: (nextAssignments || []).length,
    activeCourts: (courtAssignments || []).length,
    playersOnActive: countCourts(courtAssignments),
    playersOnNext: countCourts(nextAssignments),
    waitlistCount: (waitingList || []).length,
  };
}

export function persistDebugLog(sessionId, label, payload) {
  if (!persistDebugEnabled()) return;
  console.log(`[SessionPersist:${label}]`, sessionId, payload);
}

export function persistDebugWarn(sessionId, label, payload) {
  if (!persistDebugEnabled()) return;
  console.warn(`[SessionPersist:${label}]`, sessionId, payload);
}

export { persistDebugEnabled };
